// 禁用移动端缩放功能
export function disableZoom() {
  // 创建 meta 标签
  let meta = document.createElement('meta');
  meta.name = 'viewport';
  meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
  
  // 检查是否已存在 viewport meta 标签
  let existingMeta = document.querySelector('meta[name="viewport"]');
  if (existingMeta) {
    // 如果存在，更新内容
    existingMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
  } else {
    // 如果不存在，添加新标签
    document.head.appendChild(meta);
  }
  
  // 添加触摸事件监听器来阻止缩放
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });
  
  // 阻止双击缩放
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function(event) {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });
} 